import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import "./Spinner.css";
import "react-toastify/dist/ReactToastify.css";
import "./hm-theme.css";

const AddInvoicesByAdmin = ({ isOpen, onRequestClose }) => {
  const navigate = useNavigate();

  const date = new Date();
  let day = date.getDate().toString().padStart(2, "0");
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let year = date.getFullYear();
  let currentDate = `${year}-${month}-${day}`;

  const url = "/api/invoices/create";

  const [invoiceType, setInvoiceType] = useState("");
  const [labs, setLabs] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [taxes, setTaxes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pdfFileName, setPdfFileName] = useState("");

  const [invoices, setInvoices] = useState({
    date: currentDate,
    startdate: "",
    enddate: "",
    labId: "",
    companyId: "",
    grossamount: "",
    tax: "",
    netpay: "",
    invoicenumber: "",
    createdBy: "",
    invoicesFor: "",
    createdAdminId: "",
    invoiceFile: {
      file: null,
      fileContentType: "",
      fileSize: "",
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const token = JSON.parse(localStorage.getItem("data")).token;

        const resLabs = await axios.get("/api/labdetails/getLabs", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setLabs(resLabs.data);

        const resCompanies = await axios.get("/api/companydetails/getCompanies", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCompanies(resCompanies.data);

        const taxRes = await axios.get("/api/tax", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTaxes(taxRes.data);

        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleError(error);
      }
    };
    fetchData();
  }, []);

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
    const userRole = JSON.parse(localStorage.getItem("data")).role;

    let createdBy = "";
    if (userRole === "ROLE_ADMIN" || userRole === "ROLE_SUPER") {
      createdBy = "Admin";
    } else if (userRole === "ROLE_LAB" || userRole === "ROLE_LAB_CORPORATE") {
      createdBy = "Lab";
    } else if (userRole === "ROLE_EMPLOYER") {
      createdBy = "Company";
    }

    if (
      invoices.date &&
      invoices.startdate &&
      invoices.enddate &&
      invoices.grossamount &&
      invoices.netpay &&
      invoices.invoicenumber
    ) {
      axios
        .post(
          url,
          {
            date: invoices.date,
            startdate: invoices.startdate,
            enddate: invoices.enddate,
            labId: invoices.labId,
            companyId: invoices.companyId,
            grossamount: invoices.grossamount,
            tax: invoices.tax,
            netpay: invoices.netpay,
            invoicenumber: invoices.invoicenumber,
            createdBy: createdBy,
            invoicesFor: invoiceType,
            invoiceFile: invoices.invoiceFile,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          setLoading(false);
          onRequestClose();
          setInvoices({
            date: currentDate,
            startdate: "",
            enddate: "",
            labId: "",
            companyId: "",
            grossamount: "",
            tax: "",
            netpay: "",
            invoicenumber: "",
            createdBy: "",
            invoicesFor: "",
            createdAdminId: "",
            invoiceFile: { file: null, fileContentType: "", fileSize: "" },
          });
          setPdfFileName("");
          toast.success("Invoice Added Successfully");
        })
        .catch((error) => {
          setLoading(false);
          handleError(error);
        });
    } else {
      setLoading(false);
      toast.error("Please fill out all the required fields.");
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setInvoices((prevState) => ({
      ...prevState,
      [id]: value,
    }));

    if (id === "grossamount" || id === "tax") {
      calculateNetPay({ ...invoices, [id]: value });
    }
  };

  const calculateNetPay = ({ grossamount, tax }) => {
    const grossAmountValue = parseFloat(grossamount) || 0;
    const taxValue = parseFloat(tax) || 0;
    const netPay = grossAmountValue + (grossAmountValue * taxValue) / 100;
    setInvoices((prevState) => ({
      ...prevState,
      netpay: netPay.toFixed(2),
    }));
  };

  function getBase64FromFile(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        const [metadata, content] = reader.result.split(",");
        resolve({ metadata, content });
      };
      reader.onerror = function (error) {
        reject(error);
      };
    });
  }

  const handlePdfFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setPdfFileName(file.name);
      const convertedPdf = await getBase64FromFile(file);
      setInvoices((prevState) => ({
        ...prevState,
        invoiceFile: {
          file: convertedPdf.content,
          fileSize: file.size,
          fileContentType: convertedPdf.metadata,
        },
      }));
    }
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered size="lg">
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">receipt</i>
          Add Outgoing Invoice
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          <div className="row g-3">
            {/* Invoice For */}
            <div className="col-md-6">
              <label htmlFor="invoiceType" className="form-label small fw-semibold">
                Invoice For <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                id="invoiceType"
                value={invoiceType}
                onChange={(e) => {
                  setInvoiceType(e.target.value);
                  setInvoices({ ...invoices, labId: "", companyId: "" });
                }}
                required
              >
                <option value="">Select Invoice Type</option>
                <option value="Lab">Lab</option>
                <option value="Company">Company</option>
              </select>
            </div>

            {/* Lab Select */}
            {invoiceType === "Lab" && (
              <div className="col-md-6">
                <label htmlFor="labId" className="form-label small fw-semibold">
                  Lab <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select"
                  id="labId"
                  value={invoices.labId}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Lab</option>
                  {labs.map((lab) => (
                    <option key={lab.id} value={lab.id}>
                      {lab.labname} - {lab.labcode}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Company Select */}
            {invoiceType === "Company" && (
              <div className="col-md-6">
                <label htmlFor="companyId" className="form-label small fw-semibold">
                  Company <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select"
                  id="companyId"
                  value={invoices.companyId}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Company</option>
                  {companies.map((company) => (
                    <option key={company.id} value={company.id}>
                      {company.companyname} - {company.companycode}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Start Date */}
            <div className="col-md-6">
              <label htmlFor="startdate" className="form-label small fw-semibold">
                Start Date <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                id="startdate"
                value={invoices.startdate}
                onChange={handleChange}
                required
              />
            </div>

            {/* End Date */}
            <div className="col-md-6">
              <label htmlFor="enddate" className="form-label small fw-semibold">
                End Date <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                id="enddate"
                value={invoices.enddate}
                onChange={handleChange}
                required
              />
            </div>

            {/* Gross Amount */}
            <div className="col-md-6">
              <label htmlFor="grossamount" className="form-label small fw-semibold">
                Gross Amount (₹) <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                step="0.01"
                className="form-control"
                id="grossamount"
                placeholder="0.00"
                value={invoices.grossamount}
                onChange={handleChange}
                required
              />
            </div>

            {/* Tax */}
            <div className="col-md-6">
              <label htmlFor="tax" className="form-label small fw-semibold">
                Tax (%) <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                id="tax"
                value={invoices.tax}
                onChange={handleChange}
                required
              >
                <option value="">Select Tax</option>
                {taxes.map((t) => (
                  <option key={t.id} value={t.tax}>
                    {t.tax}%
                  </option>
                ))}
              </select>
            </div>

            {/* Net Pay */}
            <div className="col-md-6">
              <label htmlFor="netpay" className="form-label small fw-semibold">
                Net Pay (₹)
              </label>
              <input
                type="number"
                className="form-control bg-light"
                id="netpay"
                value={invoices.netpay}
                readOnly
                placeholder="Calculated automatically"
              />
            </div>

            {/* Invoice Number */}
            <div className="col-md-6">
              <label htmlFor="invoicenumber" className="form-label small fw-semibold">
                Invoice Number <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="invoicenumber"
                placeholder="e.g. INV-2026-001"
                value={invoices.invoicenumber}
                onChange={handleChange}
                required
              />
            </div>

            {/* Invoice PDF File */}
            <div className="col-md-12">
              <label htmlFor="file" className="form-label small fw-semibold">
                Invoice File (PDF / Image)
              </label>
              <input
                type="file"
                className="form-control"
                id="file"
                accept=".pdf,.png,.jpg,.jpeg"
                onChange={handlePdfFileChange}
              />
              {pdfFileName && (
                <div className="mt-2">
                  <span className="hm-badge hm-badge-info d-inline-flex align-items-center gap-1">
                    <i className="material-icons" style={{ fontSize: "0.85rem" }}>
                      description
                    </i>
                    {pdfFileName}
                  </span>
                </div>
              )}
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-end gap-2 pt-3 border-top mt-4">
            <button
              type="button"
              className="btn btn-outline-secondary rounded-pill px-4"
              onClick={onRequestClose}
            >
              Close
            </button>
            <button type="submit" className="btn-hm-primary px-4" disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddInvoicesByAdmin;

